// <x-chart-card>: builds one of the ex-Vue chart cards on demand (chart-cards.js).
const chartCard = (kind, props, profile) => ({
    chart: null,
    async init() {
        const { buildCard, registerProfile } = await import('./chart-cards.js');
        registerProfile(profile);
        this.chart = buildCard(kind, this.$refs, props);
    },
    destroy() {
        this.chart?.destroy();
        this.chart = null;
    },
});

export default chartCard;
